import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { default as swal } from 'sweetalert2';


export class BaseService {

	public extractResponseData(res: Response) {
		if (res) {
			let resp: any = res;
			if (resp._body && resp._body !== '') {
				let data: any = res.json();
				return data[Object.keys(data)[0]];
			}

			return {};
		}
	}

	public handleError(error: any, queryParamError?: string): Observable<any> {
		// check if kong detects the token as invalid
		if (error.status === 401) {
			window.location.assign(process.env.LANDING_PAGES_URL + (queryParamError ? queryParamError : '?qp_alert=invalid_token_guest_error'));
			return Observable.throw(error);
		}

		console.error(error);
		swal({
			title: `Oops, there's been an error`,
			text: `Our tech team has been notified, however please email contact@hackajob.co and we'll try and solve the issue as soon as possible. Thanks and sorry for any inconvenience.`,
			type: 'error',
			showCancelButton: false,
			confirmButtonColor: '#008fb3',
			confirmButtonText: 'Ok',
			allowOutsideClick: false,
			allowEscapeKey: false
		});
		return Observable.throw(error);
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/guest/services/base.service.ts